module.exports = __webpack_public_path__ + "img/qrcode_2.d56dfd22.png";